/** @flow */
import type { StoreResourceDef } from 'app/core/types'

export const teamEpisodes: StoreResourceDef<> = {
  resourceType: 'teamEpisodes',
}
